









































































import VTextFieldWithValidation from '@/components/Inputs/VTextFieldWithValidation.vue'
import BaseVue from '@/mixins/BaseVue'
import { EnumItem } from '@/models/Enum'
import { ECustomerGroup, ExportType, SalesOrgDto } from '@/services/connecteur'
import SalesOrgsModule from '@/store/modules/SalesOrgsModule'
import { Component, Emit, Mixins, Watch } from 'vue-property-decorator'
import VSelectWithValidation from '../Inputs/VSelectWithValidation.vue'

@Component({
  components: {
    VTextFieldWithValidation,
    VSelectWithValidation
  }
})
export default class SalesOrgForm extends Mixins(BaseVue) {
  public salesOrg: SalesOrgDto = new SalesOrgDto()

  @Watch('selectedSalesOrg', { immediate: true })
  public selectedSalesOrgChanged () {
    //Le next tick est nécessaire pour le VSelect qui n'est pas actualiser sinon.
    this.$nextTick(() => {
      this.salesOrg = new SalesOrgDto(SalesOrgsModule.selectedSalesOrg)
    })
  }

  public get exportType () {
    return [
      {
        text: this.$t('salesOrg.ExportType.APO'),
        value: ExportType.APO
      },
      {
        text: this.$t('salesOrg.ExportType.O9'),
        value: ExportType.O9
      },
      {
        text: this.$t('salesOrg.ExportType.APO_AND_O9'),
        value: ExportType.APO_AND_O9
      }
    ]
  }

  public get selectedSalesOrg () {
    return SalesOrgsModule.selectedSalesOrg
  }

  public get lvlCustomerItems () {
    const items: EnumItem[] = []
    for (const lvl in ECustomerGroup) {
      if (!isNaN(+lvl)) {
        items.push({
          id: +lvl,
          name: this.$t('customerGroup.' + ECustomerGroup[lvl]).toString()
        })
      }
    }
    return items
  }

  @Emit('close')
  public close () {
    this.reset()
  }

  public reset () {
    SalesOrgsModule.updateSelectedSalesOrg()
  }

  public async validateForm () {
    try {
      const message = this.salesOrg.id > 0 ? this.$t('salesOrg.updated') : this.$t('salesOrg.added')
      await SalesOrgsModule.addOrUpdateSalesOrg(this.salesOrg)
      this.displayMessage(message)
    } catch (error) {
      this.displayError(error)
    }

    this.close()
  }

  public updateOtherCodes (sapCode: string) {
    const length = 3
    let docType = sapCode.substring(0, length)
    let quotationType = sapCode.substring(0, length)

    if (sapCode.length >= length) {
      docType += 'F'
      quotationType += 'G'
    }

    this.salesOrg.docType = docType
    this.salesOrg.fixQuotationType = quotationType
  }
}
